import { memo } from "react";

interface Props {
  className?: string;
}

function StripeIcon({ className }: Props) {
  return (
    <svg
      width="37"
      height="25"
      viewBox="0 0 37 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="1.00239"
        y="0.465279"
        width="35.0197"
        height="24.1247"
        rx="2.72375"
        fill="white"
      />
      <rect
        x="1.00239"
        y="0.465279"
        width="35.0197"
        height="24.1247"
        rx="2.72375"
        stroke="#F2F4F7"
        strokeWidth="0.778215"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5695 8.5245L17.7774 8.92042V7.42472L19.5695 7.03613V8.5245ZM23.2971 9.35298C22.5974 9.35298 22.1475 9.69025 21.8977 9.92487L21.8048 9.47029H20.2341V18.0192L22.019 17.6307L22.0262 15.5557C22.2832 15.7464 22.6616 16.0176 23.2899 16.0176C24.568 16.0176 25.7317 14.9619 25.7317 12.6377C25.7246 10.5114 24.5465 9.35298 23.2971 9.35298ZM22.8689 14.4048C22.4476 14.4048 22.1977 14.2509 22.0264 14.0602L22.0193 11.3401C22.2049 11.1275 22.4619 10.9808 22.8689 10.9808C23.5186 10.9808 23.9684 11.7287 23.9684 12.6892C23.9684 13.6716 23.5258 14.4048 22.8689 14.4048ZM31.3579 12.711C31.3579 10.834 30.4726 9.35298 28.7804 9.35298C27.0811 9.35298 26.053 10.834 26.053 12.6963C26.053 14.9032 27.2668 16.0176 29.0089 16.0176C29.8585 16.0176 30.5011 15.8197 30.9866 15.5411V14.0747C30.5011 14.324 29.9442 14.478 29.2374 14.478C28.5448 14.478 27.9308 14.2287 27.8522 13.3635H31.3436C31.3436 13.3233 31.3462 13.2323 31.3491 13.1272L31.3491 13.1259L31.3491 13.1255C31.3532 12.9818 31.3579 12.8123 31.3579 12.711ZM27.8306 12.0141C27.8306 11.1856 28.3232 10.841 28.773 10.841C29.2086 10.841 29.6727 11.1856 29.6727 12.0141H27.8306ZM17.7774 9.47794H19.5695V15.8933H17.7774V9.47794ZM15.7432 9.47772L15.8574 10.0203C16.2787 9.22844 17.114 9.38974 17.3425 9.47772V11.1641C17.1212 11.0834 16.4072 10.9808 15.9859 11.5453V15.8931H14.201V9.47772H15.7432ZM12.2872 7.88655L10.545 8.2678L10.5379 14.1406C10.5379 15.2257 11.3304 16.0249 12.3871 16.0249C12.9726 16.0249 13.401 15.9149 13.6366 15.783V14.2946C13.4081 14.3899 12.28 14.7272 12.28 13.6421V11.0392H13.6366V9.47756H12.28L12.2872 7.88655ZM8.06757 10.9443C7.68915 10.9443 7.46068 11.0543 7.46068 11.3402C7.46068 11.6524 7.85389 11.7898 8.34171 11.9602C9.13697 12.2379 10.1837 12.6035 10.1881 13.9577C10.1881 15.2701 9.1671 16.0253 7.68201 16.0253C7.06799 16.0253 6.39684 15.9007 5.73284 15.6074V13.8624C6.33258 14.1997 7.08941 14.4489 7.68201 14.4489C8.08185 14.4489 8.36744 14.339 8.36744 14.0017C8.36744 13.6559 7.94119 13.4978 7.4266 13.307C6.6429 13.0163 5.6543 12.6497 5.6543 11.4282C5.6543 10.1305 6.61818 9.3533 8.06757 9.3533C8.66017 9.3533 9.24564 9.44861 9.83825 9.69057V11.4136C9.29562 11.1129 8.6102 10.9443 8.06757 10.9443Z"
        fill="#6461FC"
      />
    </svg>
  );
}
export default memo(StripeIcon);
